export default "__VITE_ASSET__de5956c0__"